// Types
import { AI_CHAT_GROUPING_INTERVAL } from "config/config-general";
import { AiChatMessage, AiChatMessageGroup } from "types/auth";

export function groupMessages(messages: AiChatMessage[]): AiChatMessageGroup[] {
  const groups: AiChatMessageGroup[] = [];

  messages.forEach((msg) => {
    const lastGroup = groups[groups.length - 1];

    const shouldGroup =
      lastGroup &&
      lastGroup.role === msg.role &&
      msg.createdAt - lastGroup.createdAt < AI_CHAT_GROUPING_INTERVAL;

    if (shouldGroup) {
      lastGroup.messages.push(msg);

      // update group timestamp to latest message
      lastGroup.createdAt = msg.createdAt;
    } else {
      groups.push({
        id: msg.id.toString(),
        role: msg.role,
        messages: [msg],
        createdAt: msg.createdAt,
      });
    }
  });

  return groups;
}